import icons from "helpers/icons";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Sitemap from "routes/sitemap";
import ModalWrapper from "../ModalWrapper/ModalWrapper";
import styles from "./SearchModal.module.scss";
import { useQuery } from "react-query";
import useAPI from "../../../../hooks/useAPI";
import { toast } from "react-toastify";
import loadingStyles from "../../../Loading/PageLoadingBar.module.scss";
import { useTranslation } from "react-i18next";
import useDebounce from "../../../../hooks/useDebounce";

const SearchModal = ({ openModal, setOpenModal }) => {
    const { t } = useTranslation();

    const [search, setSearch] = useState("");
    const debouncedSearch = useDebounce(search, 500);
    const navigate = useNavigate();
    const api = useAPI();
    const submitHandler = (event) => {
        event.preventDefault();
        if (search.trim().length >= 3) {
            navigate(Sitemap.catalogue.search + "/" + encodeURIComponent(search.trim()));
            setSearch("");
            setOpenModal(false);
        } else {
            toast.error(t("global-header-search-messages-enter_least_3_char"));
        }
    };

    const { data, isFetching } = useQuery(["mobile-search", debouncedSearch], () => api.list("/products/search/list", { search: debouncedSearch, limit: 6 }), {
        enabled: openModal && debouncedSearch.trim().length >= 3,
        refetchOnWindowFocus: false,
    });

    const showResults = search.trim().length >= 3 && debouncedSearch === search;
    const closeSearch = () => {
        setSearch("");
        setOpenModal(false);
    };

    return (
        <ModalWrapper openModal={openModal} setOpenModal={setOpenModal} title={t("global-left_side_bar-search_modal-title")} bottomSheet>
            <form onSubmit={submitHandler} className={styles.search}>
                <input
                    type="text"
                    placeholder={t("global-left_side_bar-search_modal-text-search_products")}
                    className={styles.searchInput}
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
                <button type="submit" className={styles.searchButton} aria-label="Pretražite proizvode">
                    <img src={icons.search} alt="" />
                </button>
            </form>
            <div className={styles.results}>
                {search.length > 0 && search.trim().length < 3 && <p className={styles.message}>{t("global-header-search-messages-enter_least_3_char")}</p>}
                {search.trim().length >= 3 && (!showResults || isFetching) && (
                    <div className={styles.loading}>
                        <div className={loadingStyles.bar} role="progressbar" aria-label="Učitavanje pretrage" style={{ "--loading-color": "var(--primary-color)" }} />
                    </div>
                )}
                {showResults && !isFetching && data?.items?.length === 0 && <p className={styles.message}>{t("global-left_side_bar-search_modal-text-no_results")}</p>}
                {showResults && !isFetching && data?.items?.map((product) => (
                    <Link key={product.id} className={styles.result} to={`/katalog/artikal/${product.id}`} onClick={closeSearch}>
                        <span className={styles.thumbnail} aria-hidden="true">
                            {product.images?.[0] && <img src={product.images[0]} alt="" onError={(event) => { event.currentTarget.style.display = "none"; }} />}
                        </span>
                        <span className={styles.info}>{product.basic_data?.name}</span>
                    </Link>
                ))}
                {showResults && !isFetching && data?.pagination?.total_items > 6 && (
                    <Link className={styles.allResults} to={`${Sitemap.catalogue.search}/${encodeURIComponent(search.trim())}`} onClick={closeSearch}>
                        {`${t("global-header-search-messages-show_all_res")} (${t("global-header-search-more")} ${data.pagination.total_items - data.items.length})`}
                    </Link>
                )}
            </div>
        </ModalWrapper>
    );
};

export default SearchModal;
